import { queueTrackingEvent } from '@library/tracking-integration'

export enum TrackingActions {
  CLICK_GET_STARTED = 'click_get_started',
}

export enum LandingPageContentSections {
  EFFORTLESS_HOME_COOKING = 'effortlessHomeCooking',
  VALUE_YOU_CAN_TASTE = 'valueYouCanTaste',
  ENVIRONMENTAL_BENEFITS = 'environmentalBenefits',
}

type CTAClickTrackingData = {
  action: TrackingActions
  properties: {
    section: LandingPageContentSections
    url: string
  }
}

export function trackCTAClick(
  action: TrackingActions,
  landingPageContentSections: LandingPageContentSections,
) {
  queueTrackingEvent<CTAClickTrackingData>({
    action,
    properties: {
      section: landingPageContentSections,
      url: window.location.href,
    },
  })
}
